import { Box, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { CustomAutoComplete, CustomTextField, HorizontalForm } from '../../../common/components';
import MaterialScopeFilters from '../../components/MaterialScopeFilters';
import {
  INVENTORY_ARTICLE_STATUS_FILTER_OPTIONS,
  INVENTORY_ARTICLES_FILTER_TEXTS as TEXTS,
} from '../constants/inventoryArticlesConstants';
import { getFilterFieldSx } from '../../utils/getFilterFieldSx';

const toolbarSx = {
  px: 2.5,
  py: 1.5,
  gap: 1.25,
  alignItems: 'center',
  flexWrap: { xs: 'wrap', lg: 'nowrap' },
  overflowX: 'visible',
};

/**
 * Toolbar de filtros del inventario de artículos en una sola fila.
 * @param {Object} props
 * @param {Object} props.filters Filtros vigentes.
 * @param {Function} props.onFilterChange Recibe (nombre, valor).
 * @param {string} props.searchTerm Texto de búsqueda.
 * @param {Function} props.onSearchChange Recibe el texto de búsqueda.
 * @param {Object} props.scopeOptions Viviendas y búsqueda de materiales.
 * @returns {JSX.Element}
 */
const InventoryArticlesFilters = ({
  filters,
  onFilterChange,
  searchTerm,
  onSearchChange,
  scopeOptions,
}) => {
  return (
    <Box sx={{ backgroundColor: 'background.paper', borderBottom: '1px solid #ccc' }}>
      <HorizontalForm withBorder={false} sx={toolbarSx}>
        <CustomTextField
          label={TEXTS.search}
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder={TEXTS.searchPlaceholder}
          size="medium"
          sx={getFilterFieldSx(2, 260)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: 'primary.main' }} />
              </InputAdornment>
            ),
          }}
        />

        <CustomAutoComplete
          label={TEXTS.status}
          value={filters.status}
          options={INVENTORY_ARTICLE_STATUS_FILTER_OPTIONS}
          onChange={(event) => onFilterChange('status', event.target.value)}
          size="medium"
          sx={getFilterFieldSx()}
        />

        <MaterialScopeFilters
          options={scopeOptions}
          filters={filters}
          onChange={(event) => onFilterChange(event.target.name, event.target.value)}
          fields={['project', 'article']}
          fieldSx={getFilterFieldSx(1.5, 170)}
        />
      </HorizontalForm>
    </Box>
  );
};

export default InventoryArticlesFilters;
